import React from "react";
import { Loader, Placeholder } from "rsuite";
import style from "./css/coreloader.module.css";

function CoreLoader(props) {
  const { show, center, disableLines } = props;

  if (!show) {
    return <></>;
  }

  return (
    <div style={{ zIndex: 9 }}>
      {!disableLines && <Placeholder.Paragraph rows={8} className="p-2" />}
      <Loader className={style.coreloader} center={center ?? true} content="loading" />
    </div>
  );
}

export default CoreLoader;
